import React, { useEffect, useState } from "react";
import "./OurService.css";
import { Carousel } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import w3 from "../images/Equity-Derivative.png";
import S2 from "../images/financial-image_2991165.png";
import S3 from "../images/insurance.png";
import S4 from "../images/property.png";
import S5 from "../images/LoanagainstSecurities.png";
import S6 from "../images/w4.png";

export default function OurServices() {
  const [columns, setColumns] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  };

  useEffect(() => {
    const updateColumns = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1000) {
        setColumns(3);
      } else {
        setColumns(1);
      }
    };
    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => {
      window.removeEventListener("resize", updateColumns);
    };
  }, []);

  const serviceItems = [
    {
      to: "/services/broking",
      imgSrc: w3,
      title: "Equities & Derivatives",
      text: "Trade seamlessly into equity and derivative with CGFS, one of India’s leading stock broker.",
    },
    {
      to: "/services/distribution",
      imgSrc: S2,
      title: "Mutual Funds/IPO",
      text: "Enjoy both liquidity and transparency with excellent choices to diversify your portfolio in Mutual Funds and IPO’s.",
    },
    {
      to: "/services/insurance",
      imgSrc: S3,
      title: "Life Insurance",
      text: "Enjoy both liquidity and transparency with excellent choices to diversify your portfolio in Life Insurance.",
    },
    {
      to: "/services/advistory",
      imgSrc: S4,
      title: "Real Estate Advisory",
      text: "CGFS offers fully integrated real estate solutions to investors corporates and property owners.",
    },
    {
      to: "/services/financing",
      imgSrc: S5,
      title: "Loan against Securities",
      text: "Get quick cash for your needs without selling securities with our Loan Against Securities.",
    },
    {
      to: "/contact",
      imgSrc: S6,
      title: "24*7 Customer Support",
      text: (
        <span>
          <span style={{ fontWeight: "bold" }}>Call :</span> +91 8479089674{" "}
          <br />
          <span style={{ fontWeight: "bold" }}>Email :</span> info@cgfs.co.in
        </span>
      ),
    },
  ];
  const chunkedServiceItems = chunkArray(serviceItems, columns);
  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <>
      <div className="video-container">
      <video autoPlay loop muted className="fullscreen-video">
          <source src='/assets/video/market_-_122881 (540p).mp4' type="video/mp4"/>
          Your browser does not support the video tag.
        </video>
        <section className="service_section layout_padding">
          <div className="container">
            <div className="heading_container">
              <h2>Our Services</h2>
              <p className="welcome_text">
                Welcome to Currency Growth Financial Services, where financial
                success meets personalized service.
              </p>
            </div>
            {columns === 1 ? (
              <Carousel indicators controls>
                {serviceItems.map((item, index) => (
                  <Carousel.Item key={index}>
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{
                        width: "80%",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div
                        className={`col-md-${12 / columns} col-lg-${
                          12 / columns
                        }`}
                      >
                        <NavLink to={item.to}>
                          <div className="box">
                            <div className="img-box">
                              <img src={item.imgSrc} alt="" />
                            </div>
                            <div
                              className="detail-box"
                              style={{ marginLeft: "0px" }}
                            >
                              <h5>{item.title}</h5>
                              <p className="service-paragraph">{item.text}</p>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <Carousel
                activeIndex={activeIndex}
                onSelect={handleSelect}
                indicators
                controls
              >
                {chunkedServiceItems.map((chunk, index) => (
                  <Carousel.Item key={index}>
                    <div
                      className="row d-flex justify-content-center align-items-center"
                      style={{
                        width: "80%",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      {chunk.map((item, innerIndex) => (
                        <div
                          key={innerIndex}
                          className={`col-md-${12 / columns} col-lg-${
                            12 / columns
                          }`}
                        >
                          <NavLink to={item.to}>
                            <div className="box">
                              <div className="img-box">
                                <img src={item.imgSrc} alt="" />
                              </div>
                              <div
                                className="detail-box"
                                style={{ marginLeft: "0px" }}
                              >
                                <h5>{item.title}</h5>
                                <p className="service-paragraph">{item.text}</p>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      ))}
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
            <div className="btn-box">
              <NavLink className="nav-link" to="/services">
                View More
              </NavLink>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
